export default "__VITE_ASSET__B$ZZqzf8__"